import ParameterErrors from '../errors/ParameterErrors';
import Hotspot from '../360_react/Hotspot';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class InfoHotspot extends Hotspot{
	constructor(props){
		super(props);
		const self = this;
		const {scene360Hotspot, scene360, marzipanoScene, getIconUrlFromRelativePath, onClick}=props;
		this._expand = this._expand.bind(this);
		this._callbackClick= this._expand;
		const expandedTextElement = document.createElement('div');
		expandedTextElement.classList.add('expanded-text');
		expandedTextElement.textContent = scene360Hotspot.text;
		this.element.appendChild(expandedTextElement);
	}
	_expand(){
	}
	static create(props){
		return (props)=>new InfoHotspot(props);
	}
}
